import React, { Fragment, useEffect, useState } from 'react'
import { useLandingTutors } from '../../modules/apis/student/landing'
import { useOpenLandingTutorPopup } from '../../modules/hooks/common/useOpenLandingTutorPopup'
import useTranslation from '../../modules/i18n/useTranslation'
import { AUTO_MATHCING_ID } from '../../modules/vars'
import Col from '../basic/Col'
import TutorCardNew from '../common/TutorCardNew'
import SquareTabsSlider from './SquareTabsSlider'

const TutorCardNewTab: React.FC<any> = () => {
  const showSplitTutorPopup = useOpenLandingTutorPopup({ noActions: true })
  const { locale } = useTranslation()
  const { data: tutorData } = useLandingTutors()
  const [activeId, setActiveId] = useState(1)
  useEffect(() => {
    const load = (data) => {
      setActiveId(data.landing_tutor_categories[0].id)
    }
    if (tutorData?.success) {
      load(tutorData)
    }
  }, [locale, tutorData])

  const showTutorModal = async (e, tutorId) => {
    if (tutorId == AUTO_MATHCING_ID) return
    showSplitTutorPopup({ event: e, tutorId: tutorId })
  }

  const tabLength =
    tutorData?.landing_tutors?.filter((e) => e.category_id == activeId)[0]?.tutors?.length < 4
      ? tutorData?.landing_tutors?.filter((e) => e.category_id == activeId)[0]?.tutors?.length
      : 4

  return (
    <div>
      <SquareTabsSlider
        tabs={tutorData?.landing_tutor_categories}
        md={true}
        activeId={activeId}
        setActiveId={setActiveId}
        arrowIcon={false}
        tabLength={tabLength}
      >
        {tutorData?.landing_tutors
          .find((e) => e.category_id == activeId)
          ?.tutors.map((tutor, i) => (
            <Fragment key={i}>
              <Col clx="pr-20 ml-10" onClick={(e) => showTutorModal(e, tutor.id)}>
                <TutorCardNew item={tutor} key={i} landing={true} />
              </Col>
            </Fragment>
          ))}
      </SquareTabsSlider>
    </div>
  )
}

export default TutorCardNewTab
